import 'https://cdn.jsdelivr.net/npm/jszip@3.10.1/dist/jszip.min.js';
import 'https://cdn.jsdelivr.net/npm/file-saver@2.0.5/src/FileSaver.js';

class DownloadSelected {
  constructor() {
    this.filename = 'download.zip';
  }

  csv(data, filename) {
    const blob = new Blob([data], {type: "text/plain;charset=utf-8"});
    saveAs(blob, filename);
  }

  bundle(selector, filename, element) {
    this.filename = filename;
    this.selection = document.querySelectorAll(selector);
    const files = [];
    for (let checkbox of this.selection) {
      let urls = checkbox.value.split(',');
      for (let url of urls) {
        files.push(url);
      }
    }
    console.log('bundling:', files);
    this.zip(files, element);
  }

  async zip(urls, element) {
    element.disabled = true;
    element.setAttribute('data-busy', '');
    const zip = new JSZip();
    for (let url of urls) {
      try {
        let request = new Request(url);
        let response = await fetch(request);
        let blob = await response.blob();
        zip.file(url.split('/').pop().split('?')[0], blob);
      } catch(e) {
        console.log(e);
      }
    }
    const content = await zip.generateAsync({ type: 'blob' });
    saveAs(content, this.filename);
    element.disabled = false;
    element.removeAttribute('data-busy');
  }
}

window.downloadSelected = new DownloadSelected();
